import iReducer from 'renderer/Global/State/reducerInterface';
import FacilitiesItem from '../Facilitiesitem';
import { range } from 'lodash';
import './style.css';
import { useState, useEffect } from 'react';
import { ChevronUp, ChevronDown } from 'react-feather';
import PaginationContainer from '../PaginationContainer';

export default function Facilities({ state, dispatch }: iReducer) {
  const [warehouses, setWarehouses] = useState(state.warehouses);
  const [searchQuery, setSearchQuery] = useState('');
  const [showStorage, setShowStorage] = useState(true);
  const [showWarehouses, setShowWarehouses] = useState(true);

  const toggleStorage = () => {
    setShowStorage((showStorage) => !showStorage);
  };

  const toggleWarehouses = () => {
    setShowWarehouses((showWarehouses) => !showWarehouses);
  };

  const currentQuery = (query: string) => {
    setSearchQuery(query);
  };

  useEffect(() => {
    let _warehouses = state.warehouses;

    if (searchQuery) {
      _warehouses = _warehouses.filter((_warehouse) =>
        _warehouse
          .getNickName()
          .toLowerCase()
          .includes(searchQuery.toLowerCase())
      );
    }

    setWarehouses(_warehouses);
  }, [searchQuery, state]);

  return (
    <div className="facilitiesTable">
      <div className="inventoryHeader">
        <div>
          <div>Storage</div>
          <span>Search:</span>
          <input></input>
        </div>
        <div>
          {showStorage ? (
            <ChevronUp
              className="toggleIcon"
              size={26}
              onClick={() => toggleStorage()}
            />
          ) : (
            <ChevronDown
              className="toggleIcon"
              size={26}
              onClick={() => toggleStorage()}
            />
          )}
        </div>
      </div>

      <b>Storage:</b>
      <div>Available Probes</div>
      {showStorage ? (
        <>
          {range(0, Object.keys(state.storage.probes).length).map((i) => (
            <div key={i}>
              <div>Probe: {state.storage.probes[i].amount}</div>
              <div>
                - Target Item: {state.storage.probes[i].targetItem.displayName}
              </div>
              <div>
                - Target Location: {state.storage.probes[i].targetLocation}
              </div>
              <div>- Size: {state.storage.probes[i].upgrades.size}</div>
              <div>- Storage: {state.storage.probes[i].upgrades.storage}</div>
              <div>
                - Shielding: {state.storage.probes[i].upgrades.shielding}
              </div>
              <div>
                - ExteriorColor:{' '}
                {state.storage.probes[i].upgrades.exteriorColor}
              </div>
            </div>
          ))}
          <PaginationContainer page={1} lastPage={5} setPage={() => null} />
        </>
      ) : null}

      <div className="warehouseHeader">
        <div>
          <div>Warehouses</div>
          <span>Search</span>
          <input className="" onChange={(e) => currentQuery(e.target.value)} />
        </div>
        <div>
          {showWarehouses ? (
            <ChevronUp
              className="toggleIcon"
              size={26}
              onClick={() => toggleWarehouses()}
            />
          ) : (
            <ChevronDown
              className="toggleIcon"
              size={26}
              onClick={() => toggleWarehouses()}
            />
          )}
        </div>
      </div>
      {showWarehouses ? (
        <>
          {range(0, Object.keys(warehouses).length).map((i) => (
            <FacilitiesItem
              key={i}
              state={state}
              dispatch={dispatch}
              warehouse={warehouses[i]}
              index={i}
            />
          ))}
          <PaginationContainer page={1} lastPage={5} setPage={() => null} />
        </>
      ) : null}
    </div>
  );
}
